import {Organization} from 'app_api/me/types';
import {
  DetailedUser,
  DomainGetResponse,
  ProjectRolesPayload,
  RoleDescriptor,
  Team,
} from 'common/report/queries/app-api/legacy/org-types';
import {ExpiresUnit} from 'common/types/reports/service-accounts';

export enum TABS {
  PROJECT = `project`,
  TEAM = `team`,
  BULK = `bulk`,
}

export type ServiceAccountExpiry = {
  interval: number;
  unit: ExpiresUnit;
};

export type UserRow = {
  id: number;
  name?: string;
  nameError?: boolean;
  email: string;
  orgRole: string;
  projectIds: number[];
  projectRole: string;
  teamNames: string[];
  orgRoleError: boolean;
  projectError: boolean;
  projectRoleError: boolean;
  emailError: boolean;
  emailErrorMsg: string;
  emailInfo: boolean;
  projectIdsToDowngrade: number[];
  seeAll: boolean;
  error: string;
  expires?: ServiceAccountExpiry;
  nameErrorMsg?: string;
};

export type PartialProject = {
  name: string;
  id: number;
};

export type KeyedByOrg<T> = {[orgId: number]: T};

export type InviteUsersModalState = {
  currentTab: TABS;
  error?: string;
  isLoading: boolean;
  isOrgProjectsProp: boolean;
  orgDomains: KeyedByOrg<DomainGetResponse[]>;
  orgProjectRoles: KeyedByOrg<ProjectRolesPayload>;
  orgProjects: KeyedByOrg<PartialProject[]>;
  orgRoles: KeyedByOrg<RoleDescriptor[]>;
  orgs: Organization[];
  orgTeams: KeyedByOrg<Team[]>;
  orgUsers: KeyedByOrg<DetailedUser[]>;
  selectedOrg: Organization;
  serviceAccount: TODO;
  userFile: TODO;
  userRows: UserRow[];
};

export enum UserType {
  User = `user`,
  ServiceAccount = `serviceaccount`,
}

export type InviteUsersModalAttrsSchema = {
  open?: boolean;
  'exclude-teams'?: boolean;
  'user-type'?: UserType;
};

export type InviteUsersModalJsxProps = {
  attrs?: InviteUsersModalAttrsSchema;
  props?: {
    orgUsers?: KeyedByOrg<DetailedUser[]>;
    orgProjects?: KeyedByOrg<PartialProject[]>;
  };
  on?: TODO;
};
